import React from 'react';
import CsQnaDetailInfo from '../CsQnaDetailInfo';
import CsDetailProductInfo from '../../../common/CsDetailProductInfo';

const CsQnaDetailWrap = (props) => {
  const { form, setData, csQnaDetail, getUsersOtherQnaList, changeQnaStatus, onReply, changeQnaSecret } = props;
  const { productInfo, qnaInfo } = csQnaDetail;

  return (
    <div className="cs-qna-detail-wrap">
      {/*상품 정보*/}
      <CsDetailProductInfo productInfo={productInfo} />

      {/*문의 정보*/}
      <CsQnaDetailInfo
        form={form}
        setData={setData}
        qnaInfo={qnaInfo}
        productInfo={productInfo}
        getUsersOtherQnaList={getUsersOtherQnaList}
        changeQnaStatus={changeQnaStatus}
        onReply={onReply}
        changeQnaSecret={changeQnaSecret}
      />
    </div>
  );
};

export default CsQnaDetailWrap;
